<script lang="ts">
    import {page} from "$app/stores";
    import {CaretDownSolid, IconSolid} from "flowbite-svelte-icons";

    export let href: string;
    export let icon = CaretDownSolid;
    export let title: string;

    $: active = $page.url.pathname === href;

</script>


<a {href} class:active class="relative group">
    <IconSolid {icon} class="w-4" />
    <span>
        {title}
    </span>

    <div class="border-active"/>
</a>

<style lang="postcss">
    a {
        @apply flex flex-row items-center gap-1.5
        text-gray-500 dark:text-gray-400 whitespace-nowrap
        px-4 py-3 dark:border-gray-700;
    }

    .border-active {
        @apply absolute -bottom-[1.7px] left-0 right-0 h-[3px] bg-primary-400 dark:bg-white;
    }

    a.active {
        @apply text-primary-600 dark:text-white;
    }

    a.active .border-active {
        @apply block;
    }

    a:not(.active):hover .border-active {
        @apply block bg-primary-200 w-7/12 mx-auto;
    }

    .border-active:not(.active) {
        @apply hidden;
    }
</style>